import React, { useRef, useEffect, useState } from 'react';
import './TestimonialsSection.css';

const testimonials1 = [
  {
    name: "sashok_vlad",
    text: "норм впн, работает. купил на месяц сначала, потом продлил. инет не тормозит"
  },
  {
    name: "Владимир Александрович",
    text: "Пользуюсь уже третий месяц. Поначалу были сомнения - много развода сейчас. Но нет, работает стабильно. Главное что цена не кусается и настроить просто. Внук помог разобраться, теперь сам справляюсь."
  },
  {
    name: "neznayu_chto_pisat",
    text: "ок впн, не самый быстрый но стабильный. за полгода 2 раза только глючил"
  },
  {
    name: "Анастасия К.",
    text: "Честно говоря, брала только из-за блокировок Инстаграма. Думала на пару недель максимум. В итоге уже 4 месяца плачу - удобно оказалось. Теперь и сериалы зарубежные смотрю, и музыку слушаю которую у нас заблокировали."
  },
  {
    name: "m1xer",
    text: "играю в доту через впн, пинг +20мс но стабильно. лучше чем без него когда провайдер душит"
  },
  {
    name: "Дмитрий Сергеевич",
    text: "Работаю программистом, нужен был доступ к GitHub и Stack Overflow без проблем. Этот VPN справляется. Не самый дешевый, но зато надежный. Коллеги тоже используют."
  }
];

const testimonials2 = [
  {
    name: "xXx_killer_xXx",
    text: "братан реально работает! играю в кс без лагов, даже лучше чем раньше стало"
  },
  {
    name: "Ольга Михайловна",
    text: "Долго мучилась с настройкой, но когда разобралась - очень довольна. Теперь могу смотреть европейские новости и BBC без проблем. Дочка тоже пользуется для учебы - доступ к зарубежным библиотекам нужен был."
  },
  {
    name: "kotletka2000",
    text: "купил со скидкой на год. пока норм, месяца 3 использую. скорость ок"
  },
  {
    name: "Максим Петров",
    text: "Фрилансер, работаю с заказчиками из разных стран. Часто нужно показать что я из определенной локации. VPN справляется, IP меняется быстро. Единственное - иногда капча на сайтах вылезает, но это везде так."
  },
  {
    name: "nightwolf88",
    text: "торрент качается нормально, скорость не режет сильно. главное что айпи скрывает"
  },
  {
    name: "Светлана Игоревна",
    text: "Муж настроил для всей семьи. Дети довольны - YouTube без тормозов, я могу сериалы смотреть. Цена за семейный план адекватная. Уже полгода пользуемся, проблем не было."
  }
];


const TestimonialsSection = () => {
  const [scrollOffset1, setScrollOffset1] = useState(0);
  const [scrollOffset2, setScrollOffset2] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  
  const cardWidth = 340; // ширина карточки + gap
  const totalWidth = testimonials1.length * cardWidth;

  useEffect(() => {
    let animationId;
    
    const animate = () => {
      if (!isDragging) {
        setScrollOffset1(prev => {
          const newOffset = prev - 0.3;
          return newOffset <= -totalWidth ? 0 : newOffset;
        });
        setScrollOffset2(prev => {
          const newOffset = prev + 0.3;
          return newOffset >= 0 ? -totalWidth : newOffset;
        });
      }
      animationId = requestAnimationFrame(animate);
    };
    
    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [isDragging, totalWidth]);

  const handleDrag = (deltaX, setOffset) => {
    setOffset(prev => {
      const newOffset = prev + deltaX;
      if (newOffset > 0) return -totalWidth + (newOffset % totalWidth);
      if (newOffset <= -totalWidth) return newOffset % totalWidth;
      return newOffset;
    });
  };

  const handleMouseDown = (e, setOffset) => {
    setIsDragging(true);
    const startX = e.clientX;
    let lastX = startX;

    const handleMouseMove = (e) => {
      const deltaX = e.clientX - lastX;
      lastX = e.clientX;
      handleDrag(deltaX, setOffset);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleTouchStart = (e, setOffset) => {
    setIsDragging(true);
    const startX = e.touches[0].clientX;
    let lastX = startX;

    const handleTouchMove = (e) => {
      const deltaX = e.touches[0].clientX - lastX;
      lastX = e.touches[0].clientX;
      handleDrag(deltaX, setOffset);
    };

    const handleTouchEnd = () => {
      setIsDragging(false);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };

    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', handleTouchEnd);
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <div className="trust-badge">Нам доверяют</div>
          <h2 className="testimonials-title">RED BUTTON — выбор пользователей по всему миру</h2>
          <div className="rating-display">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="star">★</span>
              ))}
            </div>
          </div>
        </div>
        
        <div className="testimonials-wrapper">
          {/* Первый ряд */}
          <div className="testimonials-row">
            <div 
              className="testimonials-track"
              style={{ transform: `translateX(${scrollOffset1}px)` }}
              onMouseDown={(e) => handleMouseDown(e, setScrollOffset1)}
              onTouchStart={(e) => handleTouchStart(e, setScrollOffset1)}
            >
              {/* Утроенные отзывы для бесконечности */}
              {[...testimonials1, ...testimonials1, ...testimonials1].map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="card-top">
                    <div className="rating-stars">
                      ★★★★★
                    </div>
                    <div className="trustpilot-logo">
                      <img src="assets/trustpilot-logo.svg" alt="Trustpilot" />
                    </div>
                  </div>
                  
                  <div className="testimonial-content">
                    <p className="testimonial-text">{testimonial.text}</p>
                  </div>
                  
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="assets/profile.svg" alt="Avatar" />
                    </div>
                    <span className="author-name">{testimonial.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Второй ряд */}
          <div className="testimonials-row">
            <div 
              className="testimonials-track"
              style={{ transform: `translateX(${scrollOffset2}px)` }}
              onMouseDown={(e) => handleMouseDown(e, setScrollOffset2)}
              onTouchStart={(e) => handleTouchStart(e, setScrollOffset2)}
            >
              {[...testimonials2, ...testimonials2, ...testimonials2].map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="card-top">
                    <div className="rating-stars">
                      ★★★★★
                    </div>
                    <div className="trustpilot-logo">
                      <img src="assets/trustpilot-logo.svg" alt="Trustpilot" />
                    </div>
                  </div>
                  
                  <div className="testimonial-content">
                    <p className="testimonial-text">{testimonial.text}</p>
                  </div>
                  
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="assets/profile.svg" alt="Avatar" />
                    </div>
                    <span className="author-name">{testimonial.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;